export default "__VITE_ASSET__c06f5c1a__"